import { useCallback } from "react";

import { GridCellParams } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import RecentEventsHoverIcons from "../recentEvents/RecentEventsHoverIcons";

const EventSnapshotTableCell = (props: GridCellParams) => {
  const keyFrame = props?.row?.signedUrlKeyFrame;

  const mediaOutput = props?.row?.signedUrlMediaOutput;

  const memoizedKeyFrameClickCallback = useCallback((): void => {
    props?.row?.onKeyFrameClick && props?.row?.onKeyFrameClick(props);
  }, [props?.row]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        position: "relative",
      }}
    >
      <RecentEventsHoverIcons
        keyFrame={keyFrame}
        mediaOutput={mediaOutput}
        onClick={memoizedKeyFrameClickCallback}
      />
    </Box>
  );
};

export default EventSnapshotTableCell;
